import { request } from '@/shared/api/request'

export const getEmployeePhone = ({ params }) => request({ url: `contract/sl/getPhone`, method: 'POST', params: params })
